
export const environment = {
   production: 'true',
   CLIENT_ID: 'my-home',
   AZBG_USER_NAME: 'undefined',
   AZBG_PASSWORD: 'undefined',
   STS_SERVER: 'https://portal-sso.allianz.bg/auth/realms/azbg-qb',
   BORICA_URL: 'https://3dsgate.borica.bg/cgi-bin/cgi_link',
   DEPLOY_URL: 'https://myhomeqb.allianz.bg',
   APP_BASE_HREF: '/bg_BG/q-b-property.html',
   SOCKET_URL: 'wss://myhomeqb.allianz.bg/api/ws'
};
